<template>
	<div class="d-flex justify-content-center">
		<div v-show="meta.last_page > 1">
			<div v-show="meta.last_page <= 6" class="pagination">
				<div v-for="index in Math.min(meta.last_page, 6) " :key="index" class="page-item"
					:class="(meta.current_page == index) ? 'active' : ''">
					<a @click="fetchData(index)" class="page-link cursor-pointer">{{ index }}</a>
				</div>
			</div>

			<div v-show="meta.last_page > 6 && (meta.current_page < 3 || meta.current_page > meta.last_page - 2)"
				class="pagination">

				<div class="page-item" :class="(meta.current_page == 1) ? 'active' : ''">
					<a @click="fetchData(1)" class="page-link cursor-pointer">1</a>
				</div>
				<div class="page-item" :class="(meta.current_page == 2) ? 'active' : ''">
					<a @click="fetchData(2)" class="page-link cursor-pointer">2</a>
				</div>
				<div class="page-item" :class="(meta.current_page == 3) ? 'active' : ''">
					<a @click="fetchData(3)" class="page-link cursor-pointer">3</a>
				</div>

				<div class="p-1">...</div>

				<div class="page-item" :class="(meta.current_page == meta.last_page - 2) ? 'active' : ''">
					<a @click="fetchData(meta.last_page - 2)" class="page-link cursor-pointer">{{
							meta.last_page - 2
					}}</a>
				</div>
				<div class="page-item" :class="(meta.current_page == meta.last_page - 1) ? 'active' : ''">
					<a @click="fetchData(meta.last_page - 1)" class="page-link cursor-pointer">{{
							meta.last_page - 1
					}}</a>
				</div>
				<div class="page-item" :class="(meta.current_page == meta.last_page) ? 'active' : ''">
					<a @click="fetchData(meta.last_page)" class="page-link cursor-pointer">{{
							meta.last_page
					}}</a>
				</div>
			</div>


			<div v-show="meta.last_page > 6 && meta.current_page >= 3 && meta.current_page < 5" class="pagination">
				<div class="page-item" :class="(meta.current_page == 1) ? 'active' : ''">
					<a @click="fetchData(1)" class="page-link cursor-pointer">1</a>
				</div>
				<div class="page-item" :class="(meta.current_page == 2) ? 'active' : ''">
					<a @click="fetchData(2)" class="page-link cursor-pointer">2</a>
				</div>
				<div class="page-item" :class="(meta.current_page == 3) ? 'active' : ''">
					<a @click="fetchData(3)" class="page-link cursor-pointer">3</a>
				</div>
				<div class="page-item" :class="(meta.current_page == 4) ? 'active' : ''">
					<a @click="fetchData(4)" class="page-link cursor-pointer">4</a>
				</div>
				<div class="page-item" :class="(meta.current_page == 5) ? 'active' : ''">
					<a @click="fetchData(5)" class="page-link cursor-pointer">5</a>
				</div>

				<div class="p-1">...</div>

				<div class="page-item" :class="(meta.current_page == meta.last_page) ? 'active' : ''">
					<a @click="fetchData(meta.last_page)" class="page-link cursor-pointer">{{
							meta.last_page
					}}</a>
				</div>
			</div>


			<div v-show="meta.last_page > 6 && meta.current_page >= 5 && meta.current_page < meta.last_page - 3"
				class="pagination">
				<div class="page-item" :class="(meta.current_page == 1) ? 'active' : ''">
					<a @click="fetchData(1)" class="page-link cursor-pointer">1</a>
				</div>
				<div class="p-1">...</div>

				<div class="page-item" :class="(meta.current_page == meta.current_page - 1) ? 'active' : ''">
					<a @click="fetchData(meta.current_page - 1)" class="page-link cursor-pointer">{{
							meta.current_page - 1
					}}</a>
				</div>
				<div class="page-item" :class="(meta.current_page == meta.current_page) ? 'active' : ''">
					<a @click="fetchData(meta.current_page)" class="page-link cursor-pointer">{{
							meta.current_page
					}}</a>
				</div>
				<div class="page-item" :class="(meta.current_page == meta.current_page + 1) ? 'active' : ''">
					<a @click="fetchData(meta.current_page + 1)" class="page-link cursor-pointer">{{
							meta.current_page + 1
					}}</a>
				</div>

				<div class="p-1">...</div>

				<div class="page-item" :class="(meta.current_page == meta.last_page) ? 'active' : ''">
					<a @click="fetchData(meta.last_page)" class="page-link cursor-pointer">{{
							meta.last_page
					}}</a>
				</div>
			</div>


			<div v-show="meta.last_page > 6 && meta.current_page != 4 && meta.current_page >= meta.last_page - 3 && meta.current_page < meta.last_page - 1"
				class="pagination">
				<div class="page-item" :class="(meta.current_page == 1) ? 'active' : ''">
					<a @click="fetchData(1)" class="page-link cursor-pointer">1</a>
				</div>
				<div class="p-1">...</div>

				<div class="page-item" :class="(meta.current_page == meta.last_page - 4) ? 'active' : ''">
					<a @click="fetchData(meta.last_page - 4)" class="page-link cursor-pointer">{{
							meta.last_page - 4
					}}</a>
				</div>
				<div class="page-item" :class="(meta.current_page == meta.last_page - 3) ? 'active' : ''">
					<a @click="fetchData(meta.last_page - 3)" class="page-link cursor-pointer">{{
							meta.last_page - 3
					}}</a>
				</div>
				<div class="page-item" :class="(meta.current_page == meta.last_page - 2) ? 'active' : ''">
					<a @click="fetchData(meta.last_page - 2)" class="page-link cursor-pointer">{{
					meta.last_page - 2
					}}</a>
				</div>
				<div class="page-item" :class="(meta.current_page == meta.last_page - 1) ? 'active' : ''">
					<a @click="fetchData(meta.last_page - 1)" class="page-link cursor-pointer">{{
					meta.last_page - 1
					}}</a>
				</div>
				<div class="page-item" :class="(meta.current_page == meta.last_page) ? 'active' : ''">
					<a @click="fetchData(meta.last_page)" class="page-link cursor-pointer">{{
					meta.last_page
					}}</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Paginator',
	props: ['meta', 'fetchData']
}
</script>